<template>
<div>
  <div class="kaltura__media">
    <button class="back" @click.stop.prevent="back()"><i class="material-icons">arrow_back</i></button>
   <div>
      <h3 class="title">{{selectedMedia.name}}</h3>
    </div>
  </div>
  <div class="kaltura__list">
    <ul>
      <li class="kaltura__list__item" @click="selectMedia(selectedMedia.m3u8, true, 2)">
        <div class="title">M3U8</div>
      </li>
      <li class="kaltura__list__item" title="Select media" v-for="id in selectedMedia.flavorIds.split(',')" v-bind:key="id" @click.stop.prevent="selectMedia('', false, id)">
        <div class="title">{{getTitle(id)}}</div>
        <video width="300" controls :src="selectedMedia.videoUrl.replace('{flavorId}', id)"></video>
      </li>
    </ul>
  </div>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'media',
  computed: {
    ...mapGetters(['selectedMedia'])
  },
  methods: {
    ...mapActions(['setMedia', 'getVideoMeta']),
    back() {
      this.setMedia(this.selectedMedia)
    },
    selectMedia(url, hls, flavorParamsId) {
      flavorParamsId = hls ? this.selectedMedia.flavorIds.split(',')[2] : flavorParamsId
      this.getVideoMeta({mediaId: this.selectedMedia.id, flavorParamsId: flavorParamsId}).then((video) => {
        if (hls) {
          video.adaptive = [{
              type: "hls",
              url: url
          }]
        }
        video.poster = this.selectedMedia.poster
        this.$emit('inputMedia', video)
      }).catch(() => {
        this.$emit('inputMedia', {})
      })
    },
    getTitle(flavor) {
      switch (parseInt(flavor)) {
        case 0:
          return 'Original Source';
        case 1:
          return 'Audio';
        case 2:
          return 'Lowres (H264/400)';
        case 3:
          return 'Lowres (H264/600)';
        case 4:
          return 'Standard (H264/900)';
        case 5:
          return '720p (H264/1500)';
        case 6:
          return '720p (H264/1500)';
        case 7:
          return '720p (H264/2500)';
        case 8:
          return '720p (H264/2500)';
        default:
          return '';
      }
    }
  }
}
</script>
